//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'LaySelect',
  props: {
    disabled: Boolean,
    value: {
      type: [String, Number],
      default: ''
    },
    data: {
      type: Array,
      default: () => []
    },
    prop: {
      type: Object,
      default: () => {}
    },
    placeholder: {
      type: String,
      default: ''
    },
    group: Boolean,
    isSearch: false,
    isBlock: false
  },
  data: function () {
    return {
      isOpen: false,
      selected: false,
      selectText: ''
    };
  },
  computed: {
    dataList() {
      let array = this.data.filter(item=>item.value.indexOf(this.selectText)!=-1);
      if(array.length==0 && !this.selectText) {
        return this.data
      }else{
        return array
      }
    }
  },
  watch: {
    isOpen() {
      this.setDatas(this.data)
    }
  },
  created: function () {
    this.setDatas()
  },
  methods: {
    setDatas(list) {
      if (!this.group) {
        this.datas = [
          {
            data: list?list:this.dataList
          }
        ];
      } else {
        this.datas = list?list:this.dataList;
      }
    },
    handleClick: function () {
      if (!this.disabled) {
        this.isOpen = !this.isOpen;
      } else {
        this.isOpen = false;
      }
    },
    selectOption: function (item) {
      if (!this.disabled) {
        this.selectText = item[this.prop.lable];
        this.$emit('input', item[this.prop.value]);
        this.$emit('change', item[this.prop.value]);
      }
      this.handleClick();
    },
    inputChange(e) {
      this.setDatas()
      this.$emit('input', e.target.value);
      this.$emit('change', e.target.value);
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/LaySelect.vue